import React from "react";

// components
import Card from "../Card";

const skillSets = [
	{
		id: 1,
		title: "HTML",
		level: 5,
	},
	{
		id: 2,
		title: "CSS",
		level: 4,
	},
	{
		id: 3,
		title: "JavaScript",
		level: 4,
	},
	{
		id: 4,
		title: "PHP",
		level: 4,
	},
	{
		id: 5,
		title: "X++",
		level: 2,
	},
	{
		id: 6,
		title: "Reactjs",
		level: 3,
	},
	{
		id: 7,
		title: "Nodejs",
		level: 3,
	},
];

const skillSetsCards = skillSets.map((skillSet) => (
	<Card
		key={skillSet.id}
		title={skillSet.title}
		level={skillSet.level}
	/>
));

const SkillSets = () => {
	return (
		<div>
			<div className="p-5 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-5 items-center">
				{skillSetsCards}
			</div>
		</div>
	);
};

export default SkillSets;
